import React from "react";
import ReactPlayer from "react-player";

const Video = ({ data }) => {
  console.log(data);

  return (
    <>
      {(data !== null && data?.demo_video) || data?.demo_youtube ? (
        <>
          {/*<div className="title_video">{variable_47}</div>*/}
          <div className="video">
            <ReactPlayer
              className="react-player"
              style={{ marginBottom: 15, width: "100%", borderRadius: 30 }}
              controls={true}
              url={data?.demo_youtube ? data?.demo_youtube : data?.demo_video}
            />
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default Video;
